
<template>
  <v-container fluid class="px-5 pt-3">
    <v-row class="pa-3" align='center'>
      <span class="title font-weight-bold">{{ $t('pages.documents') }}</span>
      <v-spacer></v-spacer>
    </v-row>
    <!-- <base-page-title title="Cadastro de Cliente">
      <template v-slot:actions>
        <f-btn alt_label="Cadastrar de Cliente" alt_icon="mdi-plus"></f-btn>
      </template>
    </base-page-title> -->
    <document-list class="mt-5" :company_id="company_id" :model_used="'Company'"></document-list>

    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DocumentList from '../../components/document/DocumentList.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'DocumentListPage',
  //mixins: [ validations ],
  components: {
    DocumentList
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>